import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Theme,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import Header from '../components/Header';
import Section from '../components/Section';
import Title from '../components/Title';
import PostSlider from '../components/PostSlider';
import PostList from '../components/PostList';
import Footer from '../components/Footer';
import { fetchPosts, convertDocsToPosts } from '../services/posts';
import TextSearchField from '../components/TextSearchField';
import { getKeywords } from '../services/filter';
const useStyles = makeStyles((theme: Theme) => ({
  latest: {
    backgroundColor: 'white',
    paddingBottom: 16,
  },
  moreButton: {
    backgroundColor: '#7683F9',
    borderRadius: 16,
    color: 'white',
    paddingLeft: 32,
    paddingRight: 32,
  },
  loadProgress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));
const postType = 'event';
const postLength = 9;
const featuredPostLength = 5;
const loadMoreLength = 6;

const Event = () => {
  const [initLoading, setInitLoading] = useState(true);
  const [selectedFeatured, setSelectedFeatured] = useState(0);
  const { latest, loadProgress, moreButton } = useStyles();
  const [posts, setPosts] = useState<Post[]>([]);
  const [featuredPosts, setFeaturedPosts] = useState<Post[]>([]);
  const lastVisibleRef = useRef<FirestoreDocument>();
  const [loadMoreAble, setLoadMoreAble] = useState(true);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');
  useEffect(() => {
    const fetchData = async () => {
      const [postData, featuredPostData] = await Promise.all([
        fetchPosts(postType, postLength),
        fetchPosts(postType, featuredPostLength, [
          { fieldPath: 'featured', opStr: '==', value: true },
        ]),
      ]);
      setPosts(convertDocsToPosts(postData.docs));
      setFeaturedPosts(convertDocsToPosts(featuredPostData.docs));
      lastVisibleRef.current = postData.docs[postData.docs.length - 1];
      setLoadMoreAble(postData.hasOtherPage);
      setInitLoading(false);
    };
    fetchData();
  }, []);
  const handleClickShowMore = async () => {
    setLoading(true);
    const data = await fetchPosts(
      postType,
      loadMoreLength,
      [],
      lastVisibleRef.current
    );
    setPosts((state) => [...state, ...convertDocsToPosts(data.docs)]);
    setLoadMoreAble(data.hasOtherPage);
    lastVisibleRef.current = data.docs[data.docs.length - 1];
    setLoading(false);
  };
  const searchPosts = (query: string) => {
    const keywords = getKeywords(query);
    if (keywords.length === 0) return posts;
    return posts.filter(
      (post) =>
        keywords.some((keyword) =>
          post.title.toLowerCase().includes(keyword)
        ) ||
        keywords.some((keyword) => post.excerpt.toLowerCase().includes(keyword))
    );
  };
  const filteredPosts = () => {
    return searchPosts(query).map((v) => v as Post);
  };
  const handleTextSearch = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    event.persist();
    setQuery(event.target.value);
  };
  return (
    <>
      <Header />
      <Container maxWidth="md">
        <Section>
          <Title
            title="กิจกรรม"
            subtitle="ติดตามข้อมูลข่าวสารเกี่ยวกับความมั่นคงปลอดภัย"
            align="left"
          />
          <Box height={16} />
          {featuredPosts.length > 0 && (
            <PostSlider
              posts={featuredPosts}
              imageHeight={400}
              selectedIndex={selectedFeatured}
              onPageClick={(index) => setSelectedFeatured(index)}
              type={postType}
            />
          )}
        </Section>
      </Container>
      <div className={latest}>
        <Container maxWidth="md">
          <Box height={16} />
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h4" color="textPrimary">
              กิจกรรมล่าสุด
            </Typography>
            <TextSearchField
              value={query}
              onChange={handleTextSearch}
              onClear={() => setQuery('')}
            />
          </Box>
          <Box height={8} />
          <PostList
            posts={filteredPosts()}
            column={3}
            type={postType}
            titleSize={'h6'}
            loading={initLoading}
          />
          {loadMoreAble && filteredPosts().length > 0 && (
            <Box
              display="flex"
              justifyContent="center"
              my={2}
              position="relative"
            >
              <Button
                className={moreButton}
                variant="contained"
                color="secondary"
                onClick={handleClickShowMore}
                disabled={loading}
              >
                แสดงเพิ่ม
              </Button>
              {loading && (
                <CircularProgress size={26} className={loadProgress} />
              )}
            </Box>
          )}
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Event;
